import React from 'react';
import classnames from 'classnames';
import * as PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import EmployeeLoginFlow from './Login/EmployeeLoginFlow';
import { DevelopmentTool, useNeuroMessages } from '../../components';
import {PAGE_TYPES, useNeuroState} from '../../state';
import { getMessages } from '../../utils/helpers/messageHelper';
import {useGuideConfig, usePages} from '../../hooks';
/**
 * Common container for the neuro-app to provide a consistent structure for
 * classnames based on the state of the app. Also requires the consumer to use an
 * ErrorBoundary
 */
const GuideAppContainer = ({ children, className, useDevelopmentTool = true, useToast = true }) => {
  const { employeeLoginState } = useNeuroState();
  const { savedPages, isLoadingNextPage, currentPageType } = usePages();
  const { isBranchGuide, isRemoteSession, isDemoMode } = useGuideConfig();
  const location = useLocation();
  const messageContext = useNeuroMessages();
  const currentPage = savedPages && savedPages[location.pathname] || {};
  const loginFlowEnabled = employeeLoginState?.loginFlowEnabled;
  const shouldPresentLoginFlow = loginFlowEnabled && isBranchGuide && !isRemoteSession;

  const getAppPageTypeModifier = () => {
    let result = '';
    const pathname = location.pathname;
    if (pathname === '/guide' || (isDemoMode && currentPageType === PAGE_TYPES.landingPage)) {
      result = 'app--landingPage';
    } else if (pathname.includes('spa') || (isDemoMode && currentPageType === PAGE_TYPES.surveyPage)) {
      result = 'app--surveyPage';
    } else if (pathname.includes('summary') || (isDemoMode && currentPageType === PAGE_TYPES.summaryPage)) {
      result = 'app--summaryPage';
    } else if (pathname.includes('details') || (isDemoMode && currentPageType === PAGE_TYPES.detailsPage)) {
      result = 'app--detailsPage';
    }
    return result;
  };

  const pathName = currentPage.path ? currentPage.path.key : '';
  const pageName = currentPage.page ? currentPage.page.key : '';
  const appClasses = classnames(
    'app',
    getAppPageTypeModifier(location.pathname),
    className,
    {
      [`app--path-${pathName}`]: pathName,
      [`app--page-${pageName}`]: pageName,
      ['app--processing']: isLoadingNextPage,
    }
  );

  return (
    <div className={appClasses}>
      { shouldPresentLoginFlow && <EmployeeLoginFlow messages={getMessages(messageContext.locale)} /> }
      {children}
      {useDevelopmentTool && <DevelopmentTool />}
      {useToast && <ToastContainer />}
    </div>
  );
};

GuideAppContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  useDevelopmentTool: PropTypes.bool,
  useToast: PropTypes.bool,
};
export default GuideAppContainer;
